import { render, staticRenderFns } from "./ItemSubscription.vue?vue&type=template&id=cddcfbbe&scoped=true&"
import script from "./ItemSubscription.vue?vue&type=script&lang=js&"
export * from "./ItemSubscription.vue?vue&type=script&lang=js&"
import style0 from "./ItemSubscription.vue?vue&type=style&index=0&id=cddcfbbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cddcfbbe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
